exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".attachmentContainer[_v-973d2828]{margin:auto;width:100%;height:100%;overflow:hidden;display:-ms-flexbox;display:flex;padding:5px;border:1px solid gray}.attachmentContainer>[_v-973d2828]{margin:auto}.attachmentContainer>div>[_v-973d2828]{max-width:100%}.attachmentContainer>div>video[_v-973d2828]{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-973d2828&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/pages/Attachment.vue
// module id = 319
// module chunks = 0